export default __webpack_public_path__ + "static/media/nsut-logo-new.6178c3b0.png";